import React, { Component } from "react";
import PropTypes from "prop-types";
import { RestClient } from "../restClient";
import { Responsive, GET_LIST, translate } from "admin-on-rest";
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableHeader,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import Chip from "material-ui/Chip";
import CurrencyField from "../components/CurrencyField";
import { blue300, red300 } from "material-ui/styles/colors";
import styled from "styled-components";

class MarketerTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemTransaction: props.itemTransaction || []
    };
    this.loadTransactions();
  }

  loadTransactions = () => {
    let url = "marketers/" + this.props.idMarketer + "/transactions";
    const options = {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "created_at", order: "DESC" }
    };
    RestClient(GET_LIST, url, options)
      .then(items => {
        this.setState({
          itemTransaction: items.data
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  renderTransactionsFields = (item, index) => {
    const date =
      item.created_at instanceof Date
        ? item.created_at
        : new Date(item.created_at);
    const dateString = date.toLocaleDateString();
    return (
      <TableRow key={index}>
        <TableRowColumn>{item.description}</TableRowColumn>
        <TableRowColumn>
          <ContainerChip>
            <CurrencyField
              hintText="Amount"
              underlineShow={false}
              precision={0}
              separator=""
              delimiter="."
              value={item.amount}
              unit="Rp"
            />{" "}
            &nbsp;&nbsp; {this.renderCredit(item.credit)}
          </ContainerChip>
        </TableRowColumn>
        <TableRowColumn>{item.reference}</TableRowColumn>
        <TableRowColumn>{dateString}</TableRowColumn>
      </TableRow>
    );
  };
  renderTransactionsFieldsSmall = (item, index) => {
    const { translate } = this.props;
    const date =
      item.created_at instanceof Date
        ? item.created_at
        : new Date(item.created_at);
    const dateString = date.toLocaleDateString();
    return (
      <TableRow key={index}>
        <TableRowColumn>
          <ItemBoxSmall>
            <div>
              {translate("resources.marketers.transactions.transaction")}
            </div>
            <div>{item.description}</div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <ContainerText>
              {translate("resources.marketers.transactions.amount")}
            </ContainerText>
            <div>
              <ContainerChip>
                <CurrencyField
                  hintText="Amount"
                  underlineShow={false}
                  precision={0}
                  separator=""
                  delimiter="."
                  value={item.amount}
                  unit="Rp"
                />{" "}
                &nbsp;&nbsp; {this.renderCredit(item.credit)}
              </ContainerChip>
            </div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <div>{translate("resources.marketers.transactions.reference")}</div>
            <div>{item.reference}</div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <div>{translate("resources.marketers.transactions.create_at")}</div>
            <div>{dateString}</div>
          </ItemBoxSmall>
        </TableRowColumn>
      </TableRow>
    );
  };

  renderCredit = credit => {
    if (credit) {
      return (
        <span>
          <Chip style={{ margin: 4 }} backgroundColor={red300}>
            CR
          </Chip>
        </span>
      );
    }
    return (
      <span>
        <Chip style={{ margin: 4 }} backgroundColor={blue300}>
          DB
        </Chip>
      </span>
    );
  };

  render() {
    const { translate } = this.props;
    return (
      <div>
        <Responsive
          small={
            <Table selectable={false}>
              <TableBody displayRowCheckbox={false}>
                >
                {this.state.itemTransaction.length > 0 &&
                  this.state.itemTransaction.map(
                    this.renderTransactionsFieldsSmall
                  )}
              </TableBody>
            </Table>
          }
          medium={
            <Table selectable={false}>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                <TableRow>
                  <TableHeaderColumn>
                    {translate("resources.marketers.transactions.transaction")}
                  </TableHeaderColumn>
                  <TableHeaderColumn>
                    {translate("resources.marketers.transactions.amount")}
                  </TableHeaderColumn>
                  <TableHeaderColumn>
                    {translate("resources.marketers.transactions.reference")}
                  </TableHeaderColumn>
                  <TableHeaderColumn>
                    {translate("resources.marketers.transactions.create_at")}
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {this.state.itemTransaction.length > 0 &&
                  this.state.itemTransaction.map(this.renderTransactionsFields)}
              </TableBody>
            </Table>
          }
        />
      </div>
    );
  }
}

const ContainerChip = styled.div`
  flex-direction: row;
  flex: 1;
  display: flex;
  align-items: center;
`;

const ContainerText = styled.div`
  margin-left: 0;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const ItemBoxSmall = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 8px;
`;

MarketerTransactions.propTypes = {
  idMarketer: PropTypes.number,
  translate: PropTypes.func
};

export default translate(MarketerTransactions);



// WEBPACK FOOTER //
// ./src/marketers/MarketerTransactions.js